import React, { useContext } from 'react';
import { propType as clientPropType } from './client';
import DataProvidersContext from './data-providers-context';
export var ClientContext = /*#__PURE__*/React.createContext();
export var RenderPromisesContext = /*#__PURE__*/React.createContext();

var StructuredContentProvider = function StructuredContentProvider(_ref) {
  var children = _ref.children,
      client = _ref.client;
  var renderPromisesFromContext = useContext(RenderPromisesContext); // Always prefer renderPromises from top-most StructuredContentProvider in tree
  // this allows SSR getDataFromTree to work with all clients in play in the tree

  var renderPromises = renderPromisesFromContext || client.renderPromises; // add client to renderPromises clients Set

  renderPromises.addClient(client);
  return /*#__PURE__*/React.createElement(ClientContext.Provider, {
    value: client
  }, /*#__PURE__*/React.createElement(RenderPromisesContext.Provider, {
    value: renderPromises
  }, /*#__PURE__*/React.createElement(DataProvidersContext.Provider, {
    value: client.dataProviders
  }, children)));
};

if (process.env.NODE_ENV !== 'production') {
  var PropTypes = require('prop-types'); // eslint-disable-line global-require


  StructuredContentProvider.propTypes = {
    children: PropTypes.node.isRequired,

    /**
     * Structured Content Client, instance of createClient({ schema, components, providers })
     */
    client: clientPropType.isRequired
  };
}

export default StructuredContentProvider;